import { BID_SCHEDULED_STATUS, BID_STATUS, BID_SORT_BY_TYPES, ALL_BID_DAYS_OFF_FILTERS } from "../bid/bidConstants";

const bidStatusesOrder = [
  BID_STATUS.PENDING,
  BID_STATUS.OPEN,
  BID_STATUS.CLOSED,
  BID_STATUS.AWARDED,
  BID_STATUS.WITHDRAWN,
  BID_STATUS.DELETED,
];

const scheduledStatusesOrder = [
  BID_SCHEDULED_STATUS.DELAYED,
  BID_SCHEDULED_STATUS.NOT_SCHEDULED,
  BID_SCHEDULED_STATUS.SCHEDULED,
];

export function getSortedBidsByStartDateAndEndDate(bid1, bid2) {
  const startDate1 = bid1.startDate?.toMillis();
  const startDate2 = bid2.startDate?.toMillis();

  const endDate1 = bid1.endDate?.toMillis();
  const endDate2 = bid2.endDate?.toMillis();

  // empty dates should come first
  if (!startDate1 || !endDate1) {
    return -1;
  }
  if (!startDate2 || !endDate2) {
    return 1;
  }

  // sort by start date first and end date later
  return startDate1 !== startDate2 ? startDate1 - startDate2 : endDate1 - endDate2;
}

export function getSortedBidsByStartDatesAndEndDates(startDate1, startDate2, endDate1, endDate2) {
  // empty dates should come first
  if (!startDate1 || !endDate1) {
    return -1;
  }
  if (!startDate2 || !endDate2) {
    return 1;
  }

  // sort by start date first and end date later
  return startDate1 !== startDate2 ? startDate1 - startDate2 : endDate1 - endDate2;
}

export function getSortedBidsByStatus(bidStatus1, bidStatus2) {
  if (bidStatus1 === bidStatus2) {
    return 0;
  }

  return bidStatusesOrder.indexOf(bidStatus1) > bidStatusesOrder.indexOf(bidStatus2) ? 1 : -1;
}

export function getSortedBidsByScheduledStatus(status1, status2) {
  if (status1 === status2) {
    return 0;
  }

  // empty status should go last
  if (status1 === "") {
    return 1;
  }
  if (status2 === "") {
    return -1;
  }

  return scheduledStatusesOrder.indexOf(status1) > scheduledStatusesOrder.indexOf(status2) ? 1 : -1;
}

export function sortEmployeeBidsByFilter(sortValue, sortedBids) {
  switch (sortValue) {
    case BID_SORT_BY_TYPES.STATUS:
      sortedBids = sortedBids.sort((a, b) => {
        return bidStatusesOrder.indexOf(a.status) - bidStatusesOrder.indexOf(b.status);
      });
      break;

    case BID_SORT_BY_TYPES.BID_TYPE:
      sortedBids = sortedBids.sort((a, b) => {
        return b.bidType > a.bidType ? -1 : 1;
      });
      break;

    case BID_SORT_BY_TYPES.LAST_UPDATED:
      sortedBids = sortedBids.sort((a, b) => {
        return a.createdAt.toMillis() - b.createdAt.toMillis();
      });
      break;

    case BID_SORT_BY_TYPES.BID_EFFECTIVE_DATES:
      sortedBids = sortedBids.sort((a, b) => {
        const startDate1 = a.schedStartDate?.toMillis();
        const startDate2 = b.schedStartDate?.toMillis();
        const endDate1 = a.schedEndDate?.toMillis();
        const endDate2 = b.schedEndDate?.toMillis();
        return getSortedBidsByStartDatesAndEndDates(startDate1, startDate2, endDate1, endDate2);
      });
      break;
    case BID_SORT_BY_TYPES.BID_WINDOW_DATES:
      sortedBids = sortedBids.sort((a, b) => {
        const startDate1 = a.windowStartDate?.toMillis();
        const startDate2 = b.windowStartDate?.toMillis();
        const endDate1 = a.windowEndDate?.toMillis();
        const endDate2 = b.windowEndDate?.toMillis();
        return getSortedBidsByStartDatesAndEndDates(startDate1, startDate2, endDate1, endDate2);
      });
      break;
    default:
      break;
  }
  return sortedBids;
}

export const sortBidDaysOffOptions = (daysOffOptions) => {
  const timeOffOrder = Object.values(ALL_BID_DAYS_OFF_FILTERS);
  daysOffOptions.sort((a, b) => timeOffOrder.indexOf(a) - timeOffOrder.indexOf(b));
  return daysOffOptions;
};
